import { SPACE_CARD_GAP_PX } from '../widgets/spaceWidget/spaceWidgetConstants';

export const HOME_SPACES_TOUR_PROXY_ID = 'home-spaces-tour-target';

const GREETING_IN_SPACES_SELECTOR =
  '#home-greeting-widget, [aria-label="Greeting Widgets"]';
/**
 * Returns the spaces carousel target for the tour.
 * When the greeting slide lives inside `#home-space-widget`, a fixed proxy
 * element is positioned over the spaces strip only (same height/width band as
 * the widget, minus the greeting card).
 */
export const resolveHomeSpacesTourElement = (
  root: ParentNode = document
): Element | null => {
  const spaceWidget = root.querySelector('#home-space-widget');
  if (!spaceWidget) {
    return null;
  }

  const greeting = spaceWidget.querySelector(GREETING_IN_SPACES_SELECTOR);
  if (!greeting) {
    removeHomeSpacesTourProxy();
    return spaceWidget;
  }

  const widgetRect = spaceWidget.getBoundingClientRect();
  const greetingRect = greeting.getBoundingClientRect();

  // Greeting sits to the left in the carousel; spaces start after it (+ gap).
  const spacesLeft = Math.min(
    Math.max(greetingRect.right + SPACE_CARD_GAP_PX, widgetRect.left),
    widgetRect.right
  );
  const width = Math.max(0, widgetRect.right - spacesLeft);

  if (width < 8) {
    // Greeting fills the visible strip (e.g. mid-scroll) — fall back to widget.
    removeHomeSpacesTourProxy();
    return spaceWidget;
  }

  let proxy = document.getElementById(HOME_SPACES_TOUR_PROXY_ID);
  if (!proxy) {
    proxy = document.createElement('div');
    proxy.id = HOME_SPACES_TOUR_PROXY_ID;
    proxy.setAttribute('aria-hidden', 'true');
    proxy.setAttribute('data-tour', 'home-spaces-carousel');
    proxy.style.position = 'fixed';
    proxy.style.pointerEvents = 'none';
    proxy.style.zIndex = '-1';
    proxy.style.margin = '0';
    proxy.style.padding = '0';
    proxy.style.border = '0';
    document.body.appendChild(proxy);
  }

  proxy.style.top = `${widgetRect.top}px`;
  proxy.style.left = `${spacesLeft}px`;
  proxy.style.width = `${width}px`;
  proxy.style.height = `${widgetRect.height}px`;

  return proxy;
};

export const removeHomeSpacesTourProxy = (): void => {
  document.getElementById(HOME_SPACES_TOUR_PROXY_ID)?.remove();
};
